<template lang="pug">
  v-dialog(:value="open"
    :max-width="350"
    persistent)
    v-card
      v-card-text
        .title.text-xs-center {{ title }}
      v-card-actions
        v-spacer
        v-btn(
          color="info"
          outline
          @click="$emit('check')") 確認
        v-spacer
</template>
<script>
export default {
  name: "CheckDialog",
  props: {
    open: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    }
  }
};
</script>
